import React from 'react'
import { css } from '@linaria/core'
import { Bleed, Bleedable, Card, colors, Row, H2 } from '@fs/zion-ui'
import PropTypes from 'prop-types'

const headerAdjustmentsCss = css`
  & h2 {
    padding: 0;
  }
`

const endElementCss = css`
  max-height: 28px;
  display: flex;
  align-items: center;
`

export default function PersonInfoCard({ children, heading, endElement, transparent, ...props }) {
  return (
    <Card edges="border" backgroundColor={transparent ? undefined : colors.gray00} {...props}>
      <Bleed all>
        <Bleedable bottom={0} sides={16} top={12}>
          <Row alignY="middle" className={headerAdjustmentsCss}>
            <H2 growX size="H5">
              {heading}
            </H2>
            <div className={endElementCss}>{endElement}</div>
          </Row>
        </Bleedable>
        <Bleedable bottom={16} sides={16} top={8}>
          {children}
        </Bleedable>
      </Bleed>
    </Card>
  )
}

// Stryker disable all
PersonInfoCard.propTypes = {
  /** Children to display in the card. Use PersonInfoCard.Header for the title. */
  children: PropTypes.node.isRequired,
  /** Heading for the card. */
  heading: PropTypes.node.isRequired,
  /** Element to display on the right of the heading. */
  endElement: PropTypes.node,
  /** boolean flag to toggle background and border display */
  transparent: PropTypes.bool,
}
